// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* DO NOT EDIT
@todo This file is copied from GUI and should be pulled out into a shared library.
See https://github.com/LLK/scratch-paint/issues/13 */

/* 35% transparent version of looks-secondary */

.button_button_EUYzi {
  background: none;
  cursor: pointer;
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
}

.button_button_EUYzi:active {
  background-color: var(
  --paint-looks-transparent,
  hsla(260, 60%, 60%, 0.35)
);
}

.button_highlighted_LYDtN.button_button_EUYzi {
  background-color: var(
  --paint-looks-transparent,
  hsla(260, 60%, 60%, 0.35)
);
}

.button_mod-disabled_cEcj7 {
  cursor: auto;
  opacity: 0.5;
}

.button_mod-disabled_cEcj7:active {
  background: none;
}
`, "",{"version":3,"sources":["webpack://./../scratch-paint/src/components/button/button.css"],"names":[],"mappings":"AAAA;;oDAEoD;;AAEpD,+CAA+C;;AAE/C;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;KACtB,sBAAsB;MACrB,qBAAqB;UACjB,iBAAiB;AAC3B;;AAEA;EACE;;;CAGD;AACD;;AAEA;EACE;;;CAGD;AACD;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["/* DO NOT EDIT\n@todo This file is copied from GUI and should be pulled out into a shared library.\nSee https://github.com/LLK/scratch-paint/issues/13 */\n\n/* 35% transparent version of looks-secondary */\n\n.button {\n  background: none;\n  cursor: pointer;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n\n.button:active {\n  background-color: var(\n  --paint-looks-transparent,\n  hsla(260, 60%, 60%, 0.35)\n);\n}\n\n.highlighted.button {\n  background-color: var(\n  --paint-looks-transparent,\n  hsla(260, 60%, 60%, 0.35)\n);\n}\n\n.mod-disabled {\n  cursor: auto;\n  opacity: 0.5;\n}\n\n.mod-disabled:active {\n  background: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `button_button_EUYzi`,
	"highlighted": `button_highlighted_LYDtN`,
	"mod-disabled": `button_mod-disabled_cEcj7`,
	"modDisabled": `button_mod-disabled_cEcj7`
};
export default ___CSS_LOADER_EXPORT___;
